import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TourMatMenuModule } from 'ngx-ui-tour-md-menu';

import { TourStepTemplateComponent } from './tour-step-template.component';
import { QuickGuideHotspotComponent } from './quick-guide-hotspot/quick-guide-hotspot.component';

@NgModule({
  declarations: [TourStepTemplateComponent, QuickGuideHotspotComponent],
  imports: [
    CommonModule,
    TourMatMenuModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
  ],
  exports: [TourStepTemplateComponent, QuickGuideHotspotComponent],
})
export class TourStepTemplateModule {}
